import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { MASHINGS_DEFAULT_STATE } from './constants';

const completedState = completeState(MASHINGS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [
    actions.GET_ALL_ADDED_MASHINGS,
    actions.ADD_MASHING,
    actions.UPDATE_MASHING,
    actions.GET_ALL_UPDATED_MASHINGS,
    actions.CREATE_MASH,
    actions.GET_ALL_MASHES,
    actions.UPDATE_MASH_BY_ID,
    actions.GET_MASH_BY_ID,
    actions.CREATE_PRODUCTION_PROCESS
  ],
  override: {
    [actions.SET_CURRENT_MASHING]: onReadValue(),
    [actions.SET_PRODUCTION_PROCESS_DATA]: onReadValue()
  }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
